<template>
  <div>
    <div class="cart"></div>
    <div class="cart_view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue'
      }
    },
    methods: {},
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";
  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .cart {
      width: 100%;
      .cart_top {
       display: none;
      }
      .cart_view {
        width: 100%;
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .cart {
      width: 100%;
      background-color: white;
      .cart_top {
        height: 95px;
        width: 100%;
        background-color: $bgcolor;
        font-size: 30px;
        line-height: 95px;
        text-align: center;
        color: $navcolor;
      }
      .cart_head {
        height: 100px;
        width: 820px;
        background-color: white;
        margin: 0 auto;
        span {
          display: inline-block;
          height: 140px;
          width: 140px;
          border-radius: 50%;
          z-index: 2;
          margin-top: -70px;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/cart/cart.vue